const validationMessages = {
    charsRemaining: (value, ruleValue) => `${ruleValue - (value ? value.length : 0)} characters remaining.`,
    isInteger: () => 'Must be an integer.',
    isRequired: () => 'Required.',
    isRequiredIfFieldHasValue: () => 'Required.',
    isRequiredIfModuleSelected: () => 'Required.',
    isRequiredTrim: () => 'Required.',
    isValidDate: () => 'Invalid Date Format.',
    isValidEmail: () => 'Must be a valid email address.',
    isValidMediaUrl: () => 'Must be a valid YouTube URL.',
    isValidTimezone: () => 'Must be a valid timezone. Click the red (?) button for help.',
    matchesPattern: () => 'Does not match the required pattern.',
    isValidSpocWidthAsync: () => 'Image width must be 430px or under.',
    isValidSpocHeightAsync: () => 'Image height must be 688px or under.'
};

export default validationMessages;


// WEBPACK FOOTER //
// ./src/constants/validationMessages.js